<div bey-headless-stepper [currentStep]="currentStep$ | async" class="h-full w-full flex flex-col [&>*]:lg:my-auto">
  <ng-template #step>
    <bey-confirm-nin (onNext)="handleStepData($event)"></bey-confirm-nin>
  </ng-template>

  <ng-template #step>
    <bey-new-pin (onNext)="handleStepData($event)"></bey-new-pin>
  </ng-template>
</div>
